import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { getSliceContent } from '../selectors';
import get from '../helpers/get';
import { linkType, colourThemeType } from '../propTypes';
import theme, { sliceColourTheme } from '../styles/theme';
import Link from './Link';

class TrayToolbar extends PureComponent {
  hasToolbarItems() {
    const { children, link } = this.props;
    return children || link;
  }

  render() {
    const {
      classes, children, link,
    } = this.props;
    if (!this.hasToolbarItems()) {
      return null;
    }
    return (
      <div className={cn(classes.toolbar, { offset: !children })}>
        {children || <div />}
        {link && <Link className={classes.link} link={link} defaultText="View All" />}
      </div>
    );
  }
}

TrayToolbar.propTypes = {
  children: PropTypes.any, // eslint-disable-line react/forbid-prop-types
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  // eslint-disable-next-line react/no-unused-prop-types -- used in mapStateToProps
  sliceId: PropTypes.number.isRequired,
  link: linkType,
  // eslint-disable-next-line react/no-unused-prop-types
  colourTheme: colourThemeType, // used in styles
};

TrayToolbar.defaultProps = {
  children: undefined,
  link: undefined,
  colourTheme: sliceColourTheme.white,
};

const mapStateToProps = (state, { sliceId }) => ({
  link: get(getSliceContent(state, sliceId), ['clickthrough']),
});

export default compose(
  connect(mapStateToProps),
  injectSheet({
    toolbar: {
      marginTop: 18,
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.up('md')]: {
        marginTop: 8,
        flexDirection: 'row',
      },
      color: ({ colourTheme: { textColour } }) => textColour,
      '& > *:first-child': {
        flexGrow: 1,
      },
      minHeight: 32,
      '&.offset': {
        [theme.breakpoints.up(450)]: {
          marginTop: -41,
        },
      },
    },
    link: {
      alignSelf: 'flex-end',
      whiteSpace: 'nowrap',
      display: 'block',
      fontFamily: theme.fonts.bold,
      fontWeight: theme.fonts.boldWeight,
      position: 'relative',
      fontSize: 14,
      textTransform: 'uppercase',
      letterSpacing: 2,
      margin: [15, -8, 0, 0],
      '$toolbar.offset &': {
        margin: [1, -8, 0, 0],
        [theme.breakpoints.up('md')]: {
          marginRight: 96,
          marginTop: 0,
        },
      },
      textDecoration: 'none !important',
      padding: 8,
      lineHeight: 'normal',
      color: 'inherit',
      [theme.breakpoints.up('md')]: {
        alignSelf: 'initial',
        marginRight: 96,
        marginTop: 0,
        fontSize: 16,
        letterSpacing: 2.3,
        lineHeight: 1.5,
      },
      '&:visited': {
        color: ({ colourTheme: { textColour } }) => textColour,
      },
      '&:hover, &:active, &:focus': {
        color: ({ colourTheme: { linkHover } }) => linkHover,
      },
      '&:after': {
        content: '""',
        left: 8,
        right: 8,
        bottom: 6,
        zIndex: 1,
        position: 'absolute',
      },
    },
  }),
)(TrayToolbar);
